import { ButtonGroup, Spacer } from "@zapier/design-system";
import { Button } from "blocks/components";
import { Modal } from "blocks/components/Modal";
import { Text } from "blocks/components/Text";

export function ModalDeleteTableRecord(props: {
  onClosed: () => void;
  onDelete: () => void;
}) {
  return (
    <Modal onClosed={props.onClosed}>
      <Text type="modalTitle">Delete this record?</Text>
      <Spacer height={50} />
      <ButtonGroup columnSize="150px" justify="start">
        <Button color="danger" onClick={props.onDelete} tabIndex={-1}>
          Delete record
        </Button>
        <Button color="secondary" onClick={props.onClosed} tabIndex={-1}>
          Cancel
        </Button>
      </ButtonGroup>
    </Modal>
  );
}
